module.exports = __webpack_public_path__ + "static/media/IconeRoboGarconDormindo.d48d5ae7.svg";